/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner } from './disable-daily-user-usage-limit200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DisableDailyUserUsageLimit200ResponseReissue } from './disable-daily-user-usage-limit200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { DisableDailyUserUsageLimit200ResponseUser } from './disable-daily-user-usage-limit200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { DisableDailyUserUsageLimit200ResponseUserAccountGroup } from './disable-daily-user-usage-limit200-response-user-account-group';

/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200Response
 */
export interface DisableDailyUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'availableCurrencies': Array<DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableDailyUserUsageLimit200ResponseUser}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'user': DisableDailyUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {DisableDailyUserUsageLimit200ResponseUserAccountGroup}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'userAccountGroup'?: DisableDailyUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {DisableDailyUserUsageLimit200ResponseReissue}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'reissue'?: DisableDailyUserUsageLimit200ResponseReissue | null;
}

export const DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum];


